import {Pipe, PipeTransform} from '@angular/core';
import {FolderComponentObject} from '../../../shared/classes/folder-component-object';
import {SavedReportComponentObject} from '../../../shared/classes/saved-report-component-object';

@Pipe({
  name: 'searchResults'
})
export class SearchResultsPipe implements PipeTransform {

  transform(items: Array<FolderComponentObject | SavedReportComponentObject>, value: string): unknown {
    return items.filter((item: FolderComponentObject | SavedReportComponentObject): boolean => item.payload.attributes.name.toLowerCase().includes(value.toLowerCase()));
  }

}
